import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import StormSurgeForecastMap from './StormSurgeMap/StormSurgeForecastMap';
import { styles } from './style';

const useStyles = makeStyles(styles);
const initPath = process.env.REACT_APP_HII_URL;

export default function StormSurge() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [listStation, setListStation] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ header: '', content: null });

  useEffect(() => {
    fetch(`${initPath}tiservice/v1/ws/cEniGCuZcTBSa3xj4A8PY187BhpExTfE/model/stromsurge/station_info`)
      .then(res => res.json())
      .then(result => {
        // console.log('result api เชื่อมมาได้ไร:', result);
        if (result.result === 'OK') {
          setListStation(result.data.station);
        }
      })
      .catch(err => console.error('fetch station error:', err));
  }, []);

  const handleModalOpen = (params) => {
    setModalContent(params);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <Box>
      {/* Title */}
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          display="flex"
          className={classes.shapeCircle}
          alignItems="center"
          justifyContent="center"
        >
          <NotificationsActiveIcon style={{ color: 'white' }} />
        </Box>
        <Box p={1}>
          <Typography variant="h6" className={classes.titlePage}>
            {t('ระบบคาดการณ์และเตือนภัยล่วงหน้าบริเวณอ่าวไทย')}
          </Typography>
        </Box>
      </Box>

      <Box
        mt={2}
        mb={2}
        style={{ width: "100%", height: "calc(100vh - 150px)", position: 'relative', overflow: 'hidden' }}
      >
        <StormSurgeForecastMap
          listStation={listStation}
          handleModalOpen={handleModalOpen}
        />
      </Box>

      <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="md" fullWidth container={() => document.fullscreenElement || document.body} style={{ zIndex: 999999 }}>
        <DialogTitle>
          {modalContent.header}
          <IconButton
            onClick={handleModalClose}
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {modalContent.content}
        </DialogContent>
      </Dialog>
    </Box>
  );
}